var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkPackageSubPageModule',{attrs:{"workpackage":_vm.workpackage,"isMobile":_vm.isMobile,"location":_vm.location,"loading":_vm.loading,"is_create_screen":_vm.is_create,"save_btn_loading":_vm.save_btn_loading,"background_color":_vm.workpackage_bg_hex,"foreground_color":_vm.workpackage_fg_hex,"header_icon":"pencil","header_text_short":_vm.$t('WorkpackageRework.Info.Log.Header').toUpperCase(),"header_text_long":_vm.$t('WorkpackageRework.Info.Log.Header').toUpperCase() + '.' + _vm.$t('WorkpackageRework.Info.Log.Entry')},on:{"headerCancel":function($event){return _vm.$router.push({
    name: `${_vm.location}WorkPackageLogList`
    })},"headerSave":function($event){_vm.save_btn_loading = true,
  _vm.createLogListComment({
      project_id: _vm.project_id,
      train_id: _vm.train_id,
      taktarea_id: _vm.taktarea_id,
      twaggon_id: _vm.twaggon_id,
      wbgroup_id: _vm.wbgroup_id,
      wbline_id: _vm.wbline_id,
      workpackage_id: _vm.workpackage_id,
      backlog: _vm.backlog,
      data: {comment: _vm.new_entry}
    }).then(() => {
      _vm.save_btn_loading = false,
      _vm.$router.push({
        name: `${_vm.location}WorkPackageLogList`,
        params: { nav_back: _vm.$route.params.nav_back},
        })
      })}},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('TextArea',{attrs:{"value":_vm.new_entry,"label":_vm.$t('WorkpackageRework.Info.Log.Comment'),"placeholder":`Write your ${_vm.$t('WorkpackageRework.Info.Log.Comment')}`,"max_char_count":300,"height":170,"background_color":_vm.workpackage_bg_hex,"foreground_color":_vm.workpackage_fg_hex},on:{"change":function($event){_vm.new_entry=$event}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }